<template>
  <div class="my-8 max-w-xl mx-auto p-8 rounded bg-white border border-gray-100 shadow">
    <img src="/img/docs/logo-fils.png" alt="logo" />
    <h1 class="text-lg font-bold text-center">Login</h1>
    <div class="my-8">
      <label for="password">Mot de passe</label>
      <input
        type="password"
        v-model="password"
        :disabled="loading"
        @keypress.enter="login"
        id="password"
        class="input"
      />
    </div>
    <button
      @click.prevent="login"
      :disabled="!password?.length || loading"
      class="bg-green-500 text-white px-2 py-1 rounded success cursor-pointer"
    >
      Login
    </button>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import useApi from '@/hooks/useApi'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  setup() {
    const api = useApi()
    const router = useRouter()
    const store = useStore()
    const password = ref('')
    const loading = ref(false)
    const login = async () => {
      if (!password.value || loading.value) return
      loading.value = true
      await api.auth
        .login({
          email: 'angelo',
          password: password.value,
        })
        .finally(() => {
          loading.value = false
        })
      router.push('/dashboard')
    }
    onMounted(() => {
      if (store.getters.isAuthenticated) {
        router.push('/dashboard')
      }
    })
    return { login, loading, password }
  },
}
</script>

<style></style>
